
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-avatars",
      function () {
        return require("private-next-pages/ai-avatars/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-avatars"])
      });
    }
  